import { BaseApiClient } from '../BaseApiClient'

export class DaData extends BaseApiClient {
  static async dadata (module, method, query, data = {}) {
    const bodyData = {
      query,
      ...data
    }

    return this.post(`dadata/${module}/${method}`, bodyData, {
      headers: this.getAuthHeaders()
    })
  }

  static async suggestFio (query, data = {}) {
    return this.dadata('suggest', 'fio', query, data)
      .then(response => response.data ? response.data.data : null)
  }

  static async suggestAddress (query, data = {}) {
    return this.dadata('suggest', 'address', query, data)
      .then(response => response.data ? response.data.data : null)
  }

  static async suggestParty (query, data = {}) {
    return this.dadata('suggest', 'party', query, data)
      .then(response => response.data ? response.data.data : null)
  }

  static async cleanName (query, data = {}) {
    return this.dadata('clean', 'name', query, data)
      .then(response => response.data ? response.data.data : null)
  }

  static async findByIdParty (query, data = {}) {
    const bodyData = {
      query,
      ...data
    }

    return this.post('dadata/find-by-id-party', bodyData, {
      headers: this.getAuthHeaders()
    })
      .then(response => response.data ? response.data.data : null)
  }
}
